import React from "react";
import { makeStyles, Dialog } from "@material-ui/core";
import clsx from "clsx";
import { connect } from "react-redux";
import LoadingCircle from "../../common/LoadingCircle";

const useStyles = makeStyles(theme => ({
  root: {
    "& .tooltipOpener:hover": {
      color: theme.variables.rootColor
    }
  },
  pricingPaper: {
    paddingLeft: "56px",
    transition: `${theme.transitions.create(["padding"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })}, ${theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })}`
  },
  vehcileExpanded: {
    paddingLeft: "448px"
  },
  pricingPaperExpanded: {
    paddingLeft: "280px"
  }
}));

function DialogWrapper(props) {
  const classes = useStyles();
  return (
    <Dialog
      fullScreen
      disableEnforceFocus
      open={props.open}
      onClose={props.handleClose}
      classes={{
        root: classes.root,
        paper: clsx(classes.pricingPaper, {
          [classes.pricingPaperExpanded]: props.drawerExpanded
          // [classes.vehcileExpanded]: props.vehcileExpanded
        })
      }}
      hideBackdrop
    >
      {props.loading && <LoadingCircle drawerExpanded={props.drawerExpanded} />}
      {props.children}
    </Dialog>
  );
}

const mapStateToProps = state => ({
  vehcileExpanded: state.account.accountDialog === "vehicles",
  drawerExpanded: state.account.accountDrawerOpen
});

export default connect(mapStateToProps)(DialogWrapper);
